<script>
import {defineComponent} from 'vue'
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";
import moment from "moment";
import BreadCrumbDynamic from "@/components/BreadCrumbDynamic.vue";

export default defineComponent({
  name: "ConsolidatedBudgetList",
  components: {BreadCrumbDynamic},
  computed: {
    moment() {
      return moment
    },
    brItems() {
      return this.$store.state.brItems
    }
  },
  data() {
    return {
      loading: false,
      parent_id: null,
      tableData: [],
      page: 1,
      totalCount: 0,
      limit: 10,
      indicatorYear: '2024',
      selectedRow: null,
      expandedRowIds: []
    }
  },
  methods: {
    onClickBrItem(id, index) {
      this.parent_id = id;
      this.$store.commit('sliceBrItems', index);
      this.getConsolidatedBudgetList()
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.getConsolidatedBudgetList();
    },
    handleSizeChange() {
      this.page = 1;
      this.getConsolidatedBudgetList();
    },
    onClickDelete(id, url) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v1/${url}/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              });
              location.reload()
              this.getConsolidatedBudgetList();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    getConsolidatedBudgetList() {
      this.loading = true;
      this.$http.get(`api/v1/consolidated-budgets`, {
        params: {
          parent_id: this.brItems[this.brItems.length - 1]?.id,
          limit: this.limit,
          offset: this.limit * (this.page - 1)
        }
      }).then(({data}) => {
        this.tableData = data.data;
        this.totalCount = data.count;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
    onClickRow(row) {
      this.parent_id = row['id'];
      this.$store.commit('updateBrItems', {
        id: row['id'],
        title: row['title']
      })
      this.getConsolidatedBudgetList()
    },
    loadIndicators(row, expandedRows) {
      let hasRow = expandedRows.findIndex(item => item.id === row['id']) < 0
      if (!hasRow) {
        this.selectedRow = row['id'];
        this.getIndicatorsByConsolidatedBudget();
      }
    },
    onchangeYear(val, id) {
      this.tableData.map(item => {
        if (item.id === id) {
          item.year = val;
        }
        return item
      })
      this.getIndicatorsByConsolidatedBudget()
    },
    getIndicatorsByConsolidatedBudget() {
      this.loading = true;
      const filterYear = this.tableData.find(item => item.id === this.selectedRow);

      this.$http.get(`api/v1/consolidated-budget-indicators`, {
        params: {
          limit: 100,
          offset: 0,
          year: filterYear?.year,
          consolidated_budget_id: this.selectedRow
        }
      }).then(({data}) => {
        this.tableData.map(item => {
          if (item.id === this.selectedRow) {
            item.children = data.data;
          }
          return item
        })
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted() {
    this.$store.commit('clearBrItems')
    this.$store.commit('updateBrItems', {
      title: 'Konsolidatsiyalangan budjet',
      id: null
    })
    this.getConsolidatedBudgetList()
  },
})
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div>
        <bread-crumb-dynamic :items="brItems" @onClickItem="onClickBrItem"/>
      </div>
      <el-button type="primary" @click="$router.push({name: 'ConsolidatedBudgetFormAdd'})">Qo'shish</el-button>
    </div>
    <el-table :data="tableData"
              class="table"
              border
              height="calc(100vh - 245px)"
              row-style="cursor:pointer"
              row-key="id"
              @expand-change="loadIndicators"
              @rowClick="onClickRow">
      <el-table-column type="expand">
        <template #default="props">
          <div class="indicators">
            <div class="header-indicator">
              <el-date-picker
                  @change="onchangeYear(props.row.id)"
                  v-model="props.row.year"
                  type="year"
                  style="width: 100px"
                  value-format="YYYY"
                  size="small"
                  placeholder="Yilni tanlang"
              />
              <el-button type="primary"
                         size="small"
                         @click="$router.push({name: 'ConsolidatedBudgetIndicatorFormAdd',params:{budget_id: props.row.id}})">
                Qo'shish
              </el-button>
            </div>
            <el-table border :data="props.row.children" size="small" class="table">
              <el-table-column type="index" label="T/R" width="80" align="center"/>
              <el-table-column prop="year" label="Yil" min-width="80"/>
              <el-table-column align="center" label="Tasdiqlangan">
                <el-table-column prop="accepted_amount" label="Miqdor (mlrd so'm)" min-width="120">
                  <template v-slot="scope">
                    {{scope.row.accepted_amount.toLocaleString('ru-RU')}}
                  </template>
                </el-table-column>
                <el-table-column prop="accepted_percent" label="YAIM ga nisbatan (%)" min-width="60"/>
              </el-table-column>
              <el-table-column align="center" label="Ijro">
                <el-table-column prop="execution_amount" label="Miqdor (mlrd so'm)" min-width="120">
                  <template v-slot="scope">
                    {{ scope.row.execution_amount.toLocaleString('ru-RU')}}
                  </template>
                </el-table-column>
                <el-table-column prop="execution_percent" label="YAIM ga nisbatan (%)" min-width="60"/>
              </el-table-column>
              <el-table-column label="" width="130" align="center">
                <template #default="scope">
                  <el-button type="primary" size="small"
                             @click.stop="$router.push({name: 'ConsolidatedBudgetIndicatorFormEdit', params:{id: scope.row.id, budget_id: props.row.id}})">
                    <img alt="" style="height: 15px" src="@/assets/images/icons/edit.svg"/>
                  </el-button>
                  <el-button type="danger" size="small"
                             @click.stop="onClickDelete(scope.row.id,'consolidated-budget-indicators')">
                    <img alt="" style="height: 15px" src="@/assets/images/icons/delete.svg"/>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column type="index" label="T/R" width="80" :index="indexMethod" align="center"/>
      <el-table-column prop="title" label="Nomi" min-width="220"/>
      <el-table-column prop="created_at" label="Yaratilgan sana" min-width="120">
        <template v-slot="scope">
          {{ moment(scope.row.created_at).format("DD.MM.YYYY") }}
        </template>
      </el-table-column>
      <el-table-column label="" width="230" align="center">
        <template #default="scope">
          <el-button type="success" size="small"
                     @click.stop="$router.push({name: 'ConsolidatedBudgetFormAdd', query:{parent: scope.row.id}})">+
          </el-button>
          <el-button type="primary" size="small"
                     @click.stop="$router.push({name: 'ConsolidatedBudgetFormEdit', params:{id: scope.row.id}})">
            Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click.stop="onClickDelete(scope.row.id,'consolidated-budgets')">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Umumiy soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="page"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
}

.indicators {
  padding: 10px;

  .header-indicator {
    display: flex;
    justify-content: right;
    margin-bottom: 10px;
    gap: 5px;
  }
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
